import { useCallback } from 'react';
import type { PagerRequestI } from '@tacans/shared-marketplace-layer';

import { useAppDispatch, useAppSelector } from 'src/hooks/app';
import { fetchNftHistoryThunk } from 'src/features/common/collectible/ducks/collectible/collectible.thunk';
import { selectNftHistory } from 'src/features/common/collectible/ducks/collectible/collectible.selectors';

export const useNftHistory = () => useAppSelector(selectNftHistory);

export const useFetchNftHistory = () => {
    const dispatch = useAppDispatch();

    return useCallback(
        async (nftId: string, pager: PagerRequestI) => {
            const res = await dispatch(fetchNftHistoryThunk({ nftId, pager }));
            return res;
        },
        [dispatch],
    );
};
